module.exports = __webpack_public_path__ + "img/v2_cup.54b70256.svg";